export default __webpack_public_path__ + "assets/facebook-off.ccb356f2.png";